export const costs = [
  'Noches en vela buscando cómo traducir conceptos de minería complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la minería no tiene nada que ver con ellos ni con su realidad cotidiana.',
  'Silencios incómodos cuando un alumno pregunta sobre depósitos minerales o métodos de explotación y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos mineros y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar geología minera, seguridad, ambiente o gestión de recursos sin los recursos adecuados.',
];
